// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"5aa2c8cb","20":"e3088954","688":"0c28ef42"}[chunkId] + ".chunk.css";
};